import React from 'react'
import Header from '../include/Header'
import Sidebar from '../include/Sidebar'
import { Link } from 'react-router-dom'

const HolidayList = () => {
    return (
        <div className="main-wrapper">
            <Header />
            <Sidebar />

            <div className="page-wrapper">
                <div className="content container-fluid">
                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col">
                                <h3 className="page-title">Holiday Management</h3>
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/admin/dashboard">Dashboard</Link></li>
                                    <li className="breadcrumb-item active">Holiday Management</li>
                                </ul>
                            </div>
                            <div className="col-auto float-end ms-auto">
                                <Link to='/admin/manage-holiday' className="btn btn-primary add-btn"><i className="fa-solid fa-plus"></i> Add Holiday</Link>
                            </div>
                        </div>
                    </div>

                    <div className="row filter-row mb-3 justify-content-end">
                        <div className="col-sm-6 col-md-3">
                            <div className="d-grid">
                                <div className="tableSearch">
                                    <form action="">
                                        <input className="form-control" type="text" placeholder="Search here" />
                                        <a href="" className="search">
                                            <i className="fa-solid fa-magnifying-glass"></i>
                                        </a>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="card p-3 ">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="table-responsive">
                                    <table className="table table-striped custom-table mb-0">
                                        <thead>
                                            <tr>
                                                <th>Sr.</th>
                                                <th>Name</th>
                                                <th>Status</th>
                                                <th className="text-end">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>1</td>
                                                <td>
                                                    <h2 className="table-avatar">
                                                        <a href="">Global Technologies</a>
                                                    </h2>
                                                </td>
                                                <td>
                                                    <div className="dropdown action-label">
                                                        <a href="#" className="btn btn-white btn-sm btn-rounded dropdown-toggle"
                                                            data-bs-toggle="dropdown" aria-expanded="false"><i
                                                                className="fa-regular fa-circle-dot text-success"></i> Active
                                                        </a>
                                                        <div className="dropdown-menu">
                                                            <a className="dropdown-item" href="#"><i
                                                                className="fa-regular fa-circle-dot text-success"></i>
                                                                Active</a>
                                                            <a className="dropdown-item" href="#"><i
                                                                className="fa-regular fa-circle-dot text-danger"></i>
                                                                Inactive</a>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td className="text-end">
                                                    <div className="dropdown dropdown-action">
                                                        <a href="#" className="action-icon dropdown-toggle"
                                                            data-bs-toggle="dropdown" aria-expanded="false"><i
                                                                className="material-icons">more_vert</i></a>
                                                        <div className="dropdown-menu dropdown-menu-right">
                                                            <a className="dropdown-item" href="#" data-bs-toggle="modal"
                                                                data-bs-target="#edit_client"><i
                                                                    className="fa-solid fa-pencil m-r-5"></i> Edit</a>
                                                            <a className="dropdown-item" href="#" data-bs-toggle="modal"
                                                                data-bs-target="#delete_client"><i
                                                                    className="fa-regular fa-trash-can m-r-5"></i> Delete</a>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="row align-center mt-3">
                                    <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6">
                                        <div className="dataTables_info" id="DataTables_Table_0_info" role="status"
                                            aria-live="polite">Showing 1 to 1 of 1 entries</div>
                                    </div>
                                    <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6 ">
                                        <div className="dataTables_paginate paging_simple_numbers"
                                            id="DataTables_Table_0_paginate">
                                            <ul className="pagination justify-content-end">
                                                <li className="paginate_button page-item previous disabled"
                                                    id="DataTables_Table_0_previous"><a href="#"
                                                        aria-controls="DataTables_Table_0" data-dt-idx="0" tabindex="0"
                                                        className="page-link">Previous</a></li>
                                                <li className="paginate_button page-item active">
                                                    <a href="#" aria-controls="DataTables_Table_0" data-dt-idx="1"
                                                        tabindex="0" className="page-link">1</a>
                                                </li>
                                                <li className="paginate_button page-item next disabled"
                                                    id="DataTables_Table_0_next"><a href="#"
                                                        aria-controls="DataTables_Table_0" data-dt-idx="2" tabindex="0"
                                                        className="page-link">Next</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default HolidayList